import { autoinject, transient } from "aurelia-dependency-injection";
import { OnboardingConfigModel } from "../../../../../../models/onboarding/onboarding.models";
import { ChildComponent } from "../../../../modules/child-component";
import { useView } from "aurelia-framework";

@autoinject()
@transient()
@useView('views/pages/admin/onboarding/steps/onboarding-terms-and-conditions/terms-and-conditions.html')
export class OnboardingTermsAndConditions extends ChildComponent<OnboardingConfigModel>
{
   
    activate(model: { item: OnboardingConfigModel }) {
        super.activate(model.item);
    }
}